// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73')
];

export const server_loads = [3];

export const dictionary = {
		"/": [8],
		"/(generated)/basalt": [~9],
		"/(generated)/blink": [~10],
		"/(generated)/boost_nova": [~11],
		"/(generated)/bridge2": [~13],
		"/(generated)/bridge": [~12],
		"/(generated)/cave": [~14],
		"/(generated)/chasms": [~15],
		"/(generated)/city": [~16],
		"/(generated)/collisiondemo": [~17],
		"/(generated)/construction": [~18],
		"/(generated)/cornered": [~19],
		"/(generated)/csgSandbox": [~20],
		"/(generated)/csm_test": [~21],
		"/(generated)/depthPrepassDemo": [~22],
		"/(generated)/factory_shader_demo": [~24],
		"/(generated)/factory": [~23],
		"/(generated)/fogTest": [~25],
		"/(generated)/fractal_cube": [~26],
		"/geodesicsTestbench": [56],
		"/(generated)/geoscript": [~27],
		"/geoscript/docs": [~57,[2]],
		"/geoscript/docs/quickstart": [58,[2]],
		"/geotoy": [~59,[3],[4]],
		"/geotoy/credits": [60,[3],[4]],
		"/geotoy/docs": [61,[3,5],[4]],
		"/geotoy/docs/editor": [62,[3,5],[4]],
		"/geotoy/edit": [63,[3],[4]],
		"/geotoy/edit/[id]": [~64,[3],[4]],
		"/geotoy/embed/[id]": [~65,[3],[4]],
		"/geotoy/history/[id]": [~66,[3],[4]],
		"/geotoy/login": [67,[3,6],[4]],
		"/geotoy/material/preview/[id]": [~68,[3],[4]],
		"/geotoy/register": [69,[3,7],[4]],
		"/geotoy/render": [70,[3],[4]],
		"/geotoy/user/[id]": [~71,[3],[4]],
		"/(generated)/gn_inst_test": [~28],
		"/(generated)/godrays_test": [~29],
		"/(generated)/holes": [~30],
		"/(generated)/infinite": [~31],
		"/(generated)/jump_pad_speedup_test": [~32],
		"/(generated)/kinematic_platforms": [~33],
		"/(generated)/mat_sandbox": [~34],
		"/(generated)/movement_v2": [~35],
		"/(generated)/nexus": [~36],
		"/(generated)/particle_conduit": [~37],
		"/pinklights": [72],
		"/(generated)/pk_pylons": [~38],
		"/(generated)/plats": [~39],
		"/(generated)/pomBench": [~40],
		"/(generated)/pomDemo": [~41],
		"/(generated)/rainy": [~42],
		"/(generated)/runeGenTest": [~43],
		"/(generated)/scene_def_test": [~44],
		"/(generated)/smoke": [~45],
		"/stadium": [73],
		"/(generated)/stone": [~46],
		"/(generated)/stronghold": [~47],
		"/(generated)/subdivided": [~48],
		"/(generated)/sunrise": [~49],
		"/(generated)/terrainSandbox": [~51],
		"/(generated)/terrainTest": [~52],
		"/(generated)/tessellationSandbox": [~53],
		"/(generated)/tutorial": [~54],
		"/(generated)/t": [~50],
		"/(generated)/walkways": [~55]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);